import React, { useEffect } from 'react'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { fetchAllAdminStripeAsync, selectAdminStripes } from './AdminStripeSlice'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { format } from 'date-fns'
import { Delete, Edit, Archive, SwapHoriz, Refresh } from '@mui/icons-material'
import { selectAuthUser } from '../auth/AuthSlice'

const AdminStripe = () => {
  const dispatch = useAppDispatch()
  const adminStripes = useAppSelector(selectAdminStripes)
  const navigate = useNavigate()
  const authUser = useAppSelector(selectAuthUser)
  useEffect(() => {
    dispatch(fetchAllAdminStripeAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))
  }, [])
  return (<div>
    <h1>Stripe Subscriptions</h1>
    <Button sx={{ marginBottom: 2 }} onClick={() => dispatch(fetchAllAdminStripeAsync({ mode: 'regular', userAuthorities: authUser?.authorities }))}><Refresh /> Reload</Button>
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Stripe ID</TableCell>
            <TableCell>User Email</TableCell>
            <TableCell>Stripe Email</TableCell>
            <TableCell>Subscription</TableCell>
            <TableCell>time</TableCell>
            <TableCell> </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {adminStripes.content?.map((row: any) => (
            <TableRow key={row.id}>
              <TableCell>{row.stripeId?.slice(-20)}</TableCell>
              <TableCell>{row.userEmail}</TableCell>
              <TableCell>{row.stripeEmail}</TableCell>
              <TableCell>{row.subscriptionDurationMode}</TableCell>
              <TableCell>{format(new Date(row.eventTime * 1000), 'yyyy-MM-dd HH:mm:ss')}</TableCell>
              <TableCell>
                <Button onClick={() => navigate(`/admin/stripe/transfer/${row.id}`)}><SwapHoriz /></Button>
                <Button onClick={() => navigate(`/admin/orgs/delete/${row.id}`)}><Delete /></Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </div>)
}

export default AdminStripe